module.exports = __webpack_public_path__ + "static/media/tri-fill.079d61b5.png";